import { Grid } from '@mui/material'
import React from 'react'
import Header from '../../Header';
import VerificationTable from '../../components/verificationscreen/VerificationTable';
import { styled } from "@mui/system";
import VerificationFilter from '../../components/verificationscreen/VerificationFilter';

const Content = styled("div")(({ theme }) => ({
    flexGrow: 1,
    paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // Add margin top here
    // marginTop: theme.spacing(10), // Adjust the spacing as needed
  }));

function Verification() {
  return (
   
    <Header
      children={
        <Content>
          <VerificationFilter/>
          <VerificationTable />
        </Content>
      }
    />

  )
}

export default Verification